// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_ct-j";
export var fulfillmentFormRail = "_ct-i";
export var headerTitleRow = "_ct-l";
export var orderDetailsWrapper = "_ct-g";
export var orderLinkTrigger = "_ct-2";
export var paymentInformationGrid = "_ct-q";
export var paymentSummaryColumn = "_ct-r";
export var phoneShipmentPickerButton = "_ct-e";
export var phoneShipmentPickerButtonContent = "_ct-f";
export var phoneShipmentPickerButtonWrapper = "_ct-d";
export var phoneShipmentPickerTrigger = "_ct-c";
export var shipmentContainer = "_ct-k";
export var shipmentDetailsMainPane = "_ct-h";
export var shipmentNavigationCard = "_ct-a";
export var shipmentNavigationEdgeTrigger = "_ct-6";
export var shipmentNavigationRail = "_ct-3";
export var shipmentNavigationRailEnter = "_ct-5";
export var shipmentNavigationRailHeader = "_ct-9";
export var shipmentNavigationRailOverlay = "_ct-4";
export var shipmentNavigationScrim = "_ct-7";
export var shipmentSummaryFact = "_ct-n";
export var shipmentSummaryGrid = "_ct-m";
export var shipmentSummaryMetadataRow = "_ct-o";
export var shipmentSummaryTags = "_ct-p";
export var shipmentWorkspace = "_ct-0";
export var shipmentWorkspaceBodyTablet = "_ct-8";
export var shipmentWorkspaceContent = "_ct-b";
export var shipmentWorkspaceHeader = "_ct-1";